import styled from "styled-components";
import { maxSize } from "../../Utils/common";
import { STYLE_TYPE, themeColor } from "../../Utils/magicStrings";



export const ConfirmWrapper = styled('div')`
    margin: auto;
    ${props => maxSize(608, props.styleType, 'width', 311)};
`;

export const ConfirmItemWrapper = styled('div')`
    flex: 0 0 auto;
    ${props => maxSize(40 , props.styleType, 'margin-top', 14)};
    ${props => maxSize(608, props.styleType, 'width', 311)};
    ${props => {
        if(props.styleType !== STYLE_TYPE.MOBILE) {
            return `
                border-bottom: 1px solid #000000;
            `
        } else {

        }
    }}
`;

export const ConfirmTitle = styled('div')`
    color: ${themeColor};
    ${props => maxSize(24, props.styleType, 'font-size', 14)};
    ${props => maxSize(6, props.styleType, 'margin-bottom', 8)};
    display: flex;
    align-items: center;
    & span{
        ${props => maxSize(0, props.styleType, 'height', 7)};
        ${props => maxSize(0, props.styleType, 'width', 7)};
        ${props => maxSize(0, props.styleType, 'margin-right', 8)};
        background-color: ${themeColor};
        border-radius: 50%;
        display: inline-block;
    }
`;

export const ConfirmContent = styled('pre')`
    white-sapce: pre-wrap: 
    ${props => maxSize(14, props.styleType, 'font-size', 10)};
    ${props => maxSize(608, props.styleType, 'width', 311)};

`;

export const ButtonWrapper = styled('div')`
    margin: auto;
    ${props => maxSize(524, props.styleType, 'width', 267)};
    ${props => maxSize(72, props.styleType, 'margin-top', 41)};

`;

export const LeftButton = styled('div')`
    display: inline-flex;
    justify-content: center;
    align-items: center;
    background-color: #DFDFDF;
    color: #979797;
    border-radius: 34px;
    text-align: center;
    ${props => maxSize(201, props.styleType, 'width', 94)};
    ${props => maxSize(68, props.styleType, 'height', 41)};
    ${props => maxSize(24, props.styleType, 'font-size', 12)};
`;

export const RightButton = styled('div')`
    display: inline-flex;
    justify-content: center;
    align-items: center;
    background-color: ${themeColor};
    color: white;
    border-radius: 34px;
    text-align: center;
    ${props => maxSize(68, props.styleType, 'height', 41)};
    ${props => maxSize(305, props.styleType, 'width', 157)};
    ${props => maxSize(18, props.styleType, 'margin-left', 16)};
    ${props => maxSize(24, props.styleType, 'font-size', 12)};
`;